import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "employabilityFormIsOpen", true);
        Vue.set(state, "opinionFormIsOpen", false);
    },
    setEmployabilityFormOpen(state) {
        state.employabilityFormIsOpen = true;
        state.opinionFormIsOpen = false;
    },
    setOpinionFormOpen(state) {
        state.employabilityFormIsOpen = false;
        state.opinionFormIsOpen = true;
    }
}
